async function uploadCategoryImage(categoryName, file) {
    const fd = new FormData();
    fd.append("categoryName", categoryName);
    fd.append("file", file); // ή files[] αν θες multi

    /*const res = await fetch("/upls/imageMG.php", {
        method: "POST",
        body: fd,
    });*/ //ORGINAL
    const res = await fetch("https://www.rotheras.gr/upls/imageMG.php", {
        method: "POST",
        body: fd,
    });//TEST DEV

    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || "Upload failed");

    // το php επιστρέφει urls: [...]
    return data.urls?.[0] ?? null;
}

export default uploadCategoryImage;